import Vue from 'vue';
import VueRouter from 'vue-router';
import {getToken} from '@/libs/util';

Vue.use(VueRouter);

const routes = [
    {
        path: '',
        component: () => import(/* webpackChunkName: "mainIndex" */ '../views/main/Index'),
        children: [
            {
                name: 'stations',
                path: '',
                component: () => import(/* webpackChunkName: "mainStations" */ '../views/main/Stations'),
            },
            {
                name: 'goods',
                path: 'goods',
                component: () => import(/* webpackChunkName: "mainGoods" */ '../views/main/Goods'),
            },
            {
                name: 'activities',
                path: 'activities',
                component: () => import(/* webpackChunkName: "mainActivities" */ '../views/main/Activities'),
            },
            {
                name: 'userCenter',
                path: 'userCenter',
                // meta: {requiredLogin: true},
                component: () => import(/* webpackChunkName: "mainUserCenter" */ '../views/main/UserCenter'),
            }
        ]
    },
    {
        name: 'scanQr',
        path: '/scanQr',
        component: () => import(/* webpackChunkName: "station" */ '../views/ScanQr')
    },
    {
        name: 'station',
        path: '/station/:stationCode',
        props: true,
        component: () => import(/* webpackChunkName: "station" */ '../views/Station')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "passwordLogin" */ '../views/PasswordLogin.vue')
    },
    {
        path: '/sms-login',
        name: 'smsLogin',
        component: () => import(/* webpackChunkName: "smsLogin" */ '../views/SmsLogin.vue')
    },
    {
        path: '/reset-password',
        name: 'restPassword',
        component: () => import(/* webpackChunkName: "restPassword" */ '../views/RestPassword.vue')
    },
    {
        path: '/gz-unbind',
        name: 'gzUnbind',
        component: () => import(/* webpackChunkName: "gzUnbind" */ '../views/GzUnbind.vue')
    },
    {
        name: 'recharge',
        path: '/recharge',
        component: () => import(/* webpackChunkName: "recharge" */ '../views/Recharge')
    },
    {
        name: 'agreement',
        path: '/agreement',
        component: () => import(/* webpackChunkName: "agreement" */ '../views/Agreement')
    },
    {
        name: 'chargeOrder',
        path: '/chargeOrder',
        component: () => import(/* webpackChunkName: "chargeOrder" */ '../views/ChargeOrder')
    },
    {
        name: 'balance',
        path: '/balance',
        component: () => import(/* webpackChunkName: "balance" */ '../views/Balance')
    },
    {
        name: 'score',
        path: '/score',
        component: () => import(/* webpackChunkName: "score" */ '../views/Score')
    },
    {
        name: 'bindCar',
        path: '/bindCar',
        props: (route) => ({query: route.query.vin}),
        component: () => import(/* webpackChunkName: "bindCar" */ '../views/BindCar')
    },
    {
        name: 'referrer',
        path: '/referrer',
        component: () => import(/* webpackChunkName: "referrer" */ '../views/Referrer')
    },
    {
        name: 'coupon',
        path: '/coupon',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/Coupon')
    },
    {
        name: 'couponUse',
        path: '/couponUse/:id',
        props: true,
        component: () => import(/* webpackChunkName: "couponUse" */ '../views/CouponUse')
    },
    {
        name: 'parkFee',
        path: '/parkFee',
        component: () => import(/* webpackChunkName: "parkFee" */ '../views/ParkFee'),
        props: (route) => ({q: route.query.q, scene: route.query.scene, orderSn: route.query.orderSn})
    },
    {
        name: 'charge',
        path: '/charge',
        component: () => import(/* webpackChunkName: "charge" */ '../views/Charge'),
        props: (route) => ({snParam: route.query.sn, gunCodeParam: route.query.gunCode})
    },
    {
        name: 'payResult',
        path: '/payResult',
        component: () => import(/* webpackChunkName: "payResult" */ '../views/PayResult'),
        props: (route) => ({typeParam: route.query.type, snParam: route.query.sn, moneyParam: route.query.money, gunCodeParam: route.query.gunCode})
    },
    {
        name: 'adminStations',
        path: '/admin/stations',
        component: () => import(/* webpackChunkName: "adminStations" */ '../views/admin/Stations')
    },
    {
        name: 'adminMaintain',
        path: '/admin/maintain/:stationCode',
        props: true,
        component: () => import(/* webpackChunkName: "adminMaintain" */ '../views/admin/Maintain')
    },
    {
        name: 'addRepair',
        path: '/admin/station/:stationCode/addRepair',
        props: true,
        component: () => import(/* webpackChunkName: "addRepair" */ '../views/admin/AddRepair')
    },
    {
        name: 'addStockLevel',
        path: '/admin/station/:stationCode/addStockLevel',
        props: true,
        component: () => import(/* webpackChunkName: "addStockLevel" */ '../views/admin/StockLevel')
    },
    {
        name: 'addDayCheck',
        path: '/admin/station/:stationCode/addDayCheck',
        props: true,
        component: () => import(/* webpackChunkName: "addDayCheck" */ '../views/admin/DayCheck')
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiredLogin)) {
        if (!getToken()) {
            next({name: 'login'});
        } else {
            next()
        }
    } else {
        next()
    }
});

export default router;
